import React from 'react'
import { connectStore } from 'redux-box'
import { ThemeButton } from '../../../../static/styled/custom.styled'
import './unassign.css'
import { module as ui } from "@st/ui";
import { module as user } from "@st/user";
import Select from 'react-select'
import { useState } from 'react';
import { useEffect } from 'react';

const UnAssignFreadomTeacher = (props) => {
  const [sections, setSections] = useState([])
  const [assignedSections, setAssignedSections] = useState([])
  const [classType, setClassType] = useState({ label: 'FFS', value: 'FFS' })

  const classTypeOptions = [
    { label: 'FFS', value: 'FFS' },
    { label: 'WOW', value: 'WOW' },
    { label: 'Both', value: 'BOTH' }
  ]

  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      position: "relative"
    }),
  };

  useEffect(() => {
    let school_class_list = []
    if (props.user.active_child) {
      const teacherId = props.user.active_child.teacher;
      props.user.active_child.school_class.forEach((section) => {
        let isAssigned = false;
        if (classType.value === 'FFS') isAssigned = section.teacher === teacherId;
        else if (classType.value === 'WOW') isAssigned = section.wow_teacher === teacherId;
        else if (classType.value === 'BOTH') isAssigned = section.teacher === teacherId || section.wow_teacher === teacherId;

        if(isAssigned){
          school_class_list.push(
            {
              value: section.id,
              label: section.name
            }
          )
        }
      })

      setAssignedSections(school_class_list)
      setSections([]) // Clear selection when type changes
    }
  }, [props.user.active_child, classType])

  const handleUnAssignTeacher = () => {
    if (sections.length === 0) {
      alert("Please select at least one section")
      return
    }
    const data = {
      is_freadom_teacher: false,
      child: props.user.active_child.id,
      school_class: sections.map((sec) => sec.value),
      class_type: classType.value
    }
    props.user.updateFreadomTeacher(data)
    props.ui.hideModal()
  }
  return (
    <div className='unlink_school_code_modal'>
      <p>Are you sure you want to remove the teacher as Freadom Teacher?</p>

      <div style={{ marginBottom: '15px' }}>
        <label style={{ fontSize: '14px', marginBottom: '5px', display: 'block' }}>Class Type</label>
        <Select
          className="dropdown-container"
          value={classType}
          onChange={(selected) => setClassType(selected)}
          options={classTypeOptions}
          placeholder="Select Class Type"
          styles={customStyles}
        />
      </div>

      {
        props.user.active_child.is_teacher && assignedSections.length > 0 ?
        <div style={{ marginBottom: '15px' }}>
          <label style={{ fontSize: '14px', marginBottom: '5px', display: 'block' }}>Sections</label>
          <Select
            className="dropdown-container"
            isMulti={true}
            value={sections}
            onChange={(selectedSection) =>
              setSections(selectedSection)
            }
            options={assignedSections && assignedSections}
            placeholder="Select Section"
            styles={customStyles}
          />
        </div>
        :
        <p>No Sections are assigned to teacher for {classType.label}.</p>
      }
      <div className='unlink_btn_container'>
        <ThemeButton onClick={() => handleUnAssignTeacher()} primary style={{ width: '50%' }} disabled={assignedSections.length === 0} >Remove</ThemeButton>
        <ThemeButton onClick={() => props.ui.hideModal()} style={{ width: '50%' }} >Cancel</ThemeButton>
      </div>

    </div>
  )
}

export default connectStore({
  ui, user
})(UnAssignFreadomTeacher)